import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation, useQuery } from 'urql';
import PageHeader from '@/components/common/PageHeader.jsx';
import { M_GENERAR_LIQUIDACION_CHOFER, Q_LIQUIDACIONES_CHOFER } from '@/graphql/choferLiquidaciones.gql.js';

const ESTADOS = ['BORRADOR', 'CERRADA', 'PAGADA', 'ANULADA'];

export default function LiquidacionesChoferesPage() {
  const [filtro, setFiltro] = useState({ chofer_id: '', desde: '', hasta: '', estado: '' });
  const sucursalId = 1;

  const [result, refresh] = useQuery({
    query: Q_LIQUIDACIONES_CHOFER,
    variables: {
      sucursal_id: sucursalId,
      chofer_id: filtro.chofer_id ? Number(filtro.chofer_id) : undefined,
      desde: filtro.desde || undefined,
      hasta: filtro.hasta || undefined,
      estado: filtro.estado || undefined,
    },
  });
  const [, generar] = useMutation(M_GENERAR_LIQUIDACION_CHOFER);

  const rows = useMemo(() => result.data?.liquidacionesChofer || [], [result.data]);

  const onGenerar = async () => {
    const choferId = Number(window.prompt('ID de chofer')); // fallback rápido
    const periodo_desde = window.prompt('Período desde (YYYY-MM-DD)');
    const periodo_hasta = window.prompt('Período hasta (YYYY-MM-DD)');
    if (!choferId || !periodo_desde || !periodo_hasta) return;
    await generar({ input: { sucursal_id: sucursalId, chofer_id: choferId, periodo_desde, periodo_hasta } });
    refresh({ requestPolicy: 'network-only' });
  };

  return (
    <div className="flex flex-col gap-4">
      <PageHeader
        title="Liquidaciones de choferes"
        description="Control financiero operativo por período con snapshot congelado."
        breadcrumbs={[{ label: 'Tesorería', href: '/tesoreria' }, { label: 'Choferes', href: '/tesoreria/choferes/liquidaciones' }]}
        actions={<button onClick={onGenerar} className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white">Generar liquidación</button>}
      />

      <section className="grid grid-cols-4 gap-3 rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.75)] p-4">
        <input className="rounded-lg border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2 text-sm" placeholder="Chofer ID" value={filtro.chofer_id} onChange={(e) => setFiltro((f) => ({ ...f, chofer_id: e.target.value }))} />
        <input type="date" className="rounded-lg border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2 text-sm" value={filtro.desde} onChange={(e) => setFiltro((f) => ({ ...f, desde: e.target.value }))} />
        <input type="date" className="rounded-lg border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2 text-sm" value={filtro.hasta} onChange={(e) => setFiltro((f) => ({ ...f, hasta: e.target.value }))} />
        <select className="rounded-lg border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2 text-sm" value={filtro.estado} onChange={(e) => setFiltro((f) => ({ ...f, estado: e.target.value }))}>
          <option value="">Todos</option>
          {ESTADOS.map((e) => <option key={e} value={e}>{e}</option>)}
        </select>
      </section>

      <section className="overflow-auto rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.75)]">
        <table className="min-w-full text-sm">
          <thead><tr className="text-left"><th className="px-3 py-2">Período</th><th>Estado</th><th>Total</th><th>Entregas</th><th>KM</th><th>Horas</th><th></th></tr></thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id} className="border-t border-[rgba(var(--border),0.5)]">
                <td className="px-3 py-2">{row.periodo_desde} a {row.periodo_hasta}</td>
                <td><span className="rounded-full bg-[rgba(var(--brand),0.14)] px-2 py-1 text-xs text-[rgb(var(--brand))]">{row.estado}</span></td>
                <td>${row.total?.toFixed?.(2) ?? row.total}</td>
                <td>{row.total_entregas}</td>
                <td>{row.total_km}</td>
                <td>{row.total_horas}</td>
                <td><Link className="text-[rgb(var(--brand))]" to={`/tesoreria/choferes/liquidaciones/${row.id}`}>Ver</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      {result.error ? <p className="text-sm text-red-500">{result.error.message}</p> : null}
    </div>
  );
}
